import React, { FC, useState } from 'react';

import { LoadPanel } from 'devextreme-react/load-panel';
import 'devextreme-react/text-area';

import { AppCol, AppRow } from 'components/appComponents';
import { TabPanel } from 'devextreme-react';

import { MaterialPrice } from '../components';
import Nomenclature from './Nomenclature';
import NomenclatureComposition from './NomenclatureComposition';
import NomenclatureCustomName from './NomenclatureCustomName';
import './recipe.sass';

const tabs = [
  {
    name: 'Спецификации',
    index: 0,
  },
  {
    name: 'Обозначения марок',
    index: 1,
  },
  {
    name: 'История цен',
    index: 2,
  },
];

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const RecipePage: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [initialId, setInitialId] = useState<number | null>(null);

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  return (
    <div className="container-dev">
      <div className="reccpe-page">
        <AppRow>
          <AppCol col={8} className="pr-3 reccpe-page__left">
            <NomenclatureMemo
              onInitialId={(id) => {
                setInitialId(id);
                setLoading(false);
              }}
              onLoaded={() => setLoading(false)}
              initialId={initialId}
            />
          </AppCol>
          <AppCol col={4} className="reccpe-page__right">
            <TabPanel
              height="auto"
              dataSource={tabs}
              selectedIndex={selectedIndex}
              onOptionChanged={(e) => {
                if (e.name === 'selectedIndex') {
                  setSelectedIndex(e.value);
                }
              }}
              itemTitleRender={itemTitleRender}
              animationEnabled={false}
            />

            {loading ? (
              <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={true} shading={true} showPane={true} />
            ) : (
              <>
                {selectedIndex === 0 && <NomenclatureComposition initialId={initialId} />}
                {selectedIndex === 1 && <NomenclatureCustomName initialId={initialId} />}
                {selectedIndex === 2 && initialId && <MaterialPrice materialId={initialId} />}
              </>
            )}
          </AppCol>
        </AppRow>
      </div>
    </div>
  );
};

export default RecipePage;

type NomenclatureMemoProps = {
  onInitialId: (e: number) => void;
  initialId: number | null;
  onLoaded: () => void;
};

const NomenclatureMemo = React.memo(
  function HouseListMemo(props: NomenclatureMemoProps) {
    return (
      <Nomenclature
        onLoaded={(data) => {
          if (data.data.length > 0) {
            props.onInitialId(data.data[0].id); //записываем первый id загруженного списка
          }
          props.onLoaded();
        }}
        changeId={(id) => {
          props.onInitialId(id);
        }}
      />
    );
  },
  (prev, next) => {
    return true;
  },
);
